import * as React from 'react'

import { OptionCheckbox, StarRating } from '@syconium/little-miss-figgy'

import { RatingWrapper } from './styles'

const ratings = ['5', '4', '3', '2', '1']

export const RatingsFilter: React.FC<{
  value: ReadonlyArray<string>
  onChange: (item: string) => void
}> = ({ value, onChange }) => {
  return (
    <div>
      {ratings.map(item => (
        <OptionCheckbox
          checked={value.includes(item)}
          key={item}
          name={item}
          onChange={() => onChange(item)}
          type='checkbox'
          value={item}
        >
          <RatingWrapper>
            <StarRating rating={+item} starSize='16px' />
          </RatingWrapper>
        </OptionCheckbox>
      ))}
    </div>
  )
}
